<template>
  <ui-side-modal v-show="show"
                 class="template-detail"
                 :width="modalWidth"
                 @close="closeModal">
    <ui-detail v-if="dataOption && dataInHand"
               :meta="dataOption"
               :data="dataInHand"
               :error="error"
               :editMode="editMode"
               @input="input"
               @set="setData"
               @error="setError" >
      <template v-if="editMode">
        <ui-button :color="'blue'"
                    @click="send()">
          <i class="xi-mail"></i> 발송
        </ui-button>
        <ui-button :color="'gray'"
                    @click="save(false)">
          <i class="xi-close"></i> 취소
        </ui-button>
      </template>
      <template v-else>
        <ui-button :color="'red'"
                    @click="create">
          <i class="xi-play-circle"></i> 답변 생성
        </ui-button>
        <ui-button :color="'yellow'"
                    @click="edit">
          <i class="xi-pen"></i> 답변 수정
        </ui-button>
      </template>
    </ui-detail>
  </ui-side-modal>
</template>

<script>
import ejs from 'ejs'
import { mapGetters } from "vuex"
import { EventBus } from '@/utils/event-bus'
import { alertError, isEndWithConsonant } from '@/utils/tools'
import { sendInboxReply, getInboxReply } from '@/api/contact'
import { getEmailTemplate } from "@/api/monitoring"

import UiDetail from '@/components/_ui/UiDetail'
import UiButton from '@/components/_ui/UiButton'
import UiSideModal from '@/components/_ui/UiSideModal'

import i18n from '@/libs/text/mailer-i18n-messages.json'

export default {
  name: 'InboxMailDetail',
  components: {
    UiDetail,
    UiButton,
    UiSideModal
  },
  props: {
    infoApi: {
      required: true
    },
    editApi: {
      required: false
    },
    removeApi: {
      required: false
    },
    apiParam: {
      type: Object,
      default: () => {
        return {}
      },
      required: false
    }
  },
  computed: {
    ...mapGetters([
      'userData'
    ]),
    modalWidth () {
      return 1000
    }
  },
  created () {
    if (this.apiParam) {
      this.loadData(() => {
        this.setEjsRendering()
      })
    }
  },
  watch: {
    editMode (value) {
      this.setEjsRendering()
    },
    apiParam (value) {
      this.editMode = false
      if (value) {
        this.loadData(() => {
          this.setEjsRendering()
        })
      }
    }
  },
  methods: {
    loadData (callback = null) {
      this.error = {}
      this.show = false
      EventBus.$emit('onLoading', true)
      setTimeout(() => {
        this.infoApi(this.apiParam, true).then(response => {
          this.dataInHand = response.result.info || null
          this.dataOption = response.result.meta || null
          
          this.show = true
        }).catch(error => {
          alertError('상세 데이터를 불러오지 못 했습니다.', error)
        }).finally(() => {
          if (callback) {
            callback()
          }
          EventBus.$emit('onLoading', false)
        })
      }, 300)
    },
    save (save = false) {
      let confirmed = confirm(save ? '정말로 저장하시겠습니까?' : '정말로 저장하지 않고 끝내시겠습니까?')

      if (confirmed) {
        if (save) {
          this.editMode = false
        } else {
          this.loadData(this.edit)
        }
      }
    },
    async create () {
      EventBus.$emit('onLoading', true)
      const payload = {
        id: this.apiParam.id,
        streaming: false,
        category: 'voc'
      }

      const res = await getInboxReply(payload)
      if (res && res.data) {
        this.dataInHand['replyContent'] = res.data
        this.setEjsRendering(true)
      } else {
        EventBus.$emit('onLoading', false)
      }
    },
    edit () {
      this.editMode = !this.editMode
      this.dataInHand.managerId = this.userData.userId
    },
    input (field, value) {
      this.setData(field, value)
    },    
    setData (field, value) {
      this.model[field] = value
      this.dataInHand[field] = value
    },
    setEjsRendering (templateChange=false) {
      this.setModel()
      EventBus.$emit('onLoading', true)
      const templateName = 'adminAi'
      if (templateName) {
        const emailData = JSON.parse(JSON.stringify(this.dataInHand))
        const templateObj = JSON.parse(JSON.stringify(emailData.template))

        let template = null
        let layout = null
        let templateEjs = null
        let serviceType = null

        if (templateObj.template) {
          template = templateObj.template
          templateEjs = template.ejs
        }

        if (templateObj.layout) {
          layout = templateObj.layout
          const replaceKey = layout.replaceKey
          const layoutEjs = layout.ejs
          const tempEjs = layoutEjs.replace(replaceKey, templateEjs)
          template.ejs = tempEjs

          serviceType = emailData.serviceType || 'beusable'
          
          const emailText = {}
          emailText.common = i18n.messages[serviceType].common
          emailData.emailText = emailText

          // 인삿말 따로 저장
          if (emailData.replyContent) {
            const dom = document.createElement("div");
            dom.innerHTML = emailData.replyContent;

            const introElement = dom.querySelector('.intro');

            if (introElement) {
              emailData.intro = introElement.innerHTML
              introElement.remove()
              emailData.content = dom.innerHTML
            }  
          } else {
            emailData.intro = ''
            emailData.content = '답변 내용을 생성해주세요.'
          }
        }

        const lang = 'ko'
        emailData.lang = lang

        for (const key in emailData) {
          if (typeof emailData[key] === 'number') {
            emailData[key] = emailData[key].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
        }

        let html = ''
        if (template.ejs && emailData) {
          if (this.dataInHand.emailHtml && !templateChange) {
            html = this.dataInHand.emailHtml
          } else {
            html = ejs.render(template.ejs, emailData)
          }
        }
        EventBus.$emit('onLoading', false)
        this.$set(this.dataInHand, 'emailHtml', html)
      }
    },
    send () {
      for (const [field, option] of Object.entries(this.dataOption.field)) {
        const key = option.field || field
        if (option.required && !this.model[key] && this.model[key] !== 0) {
          this.$set(this.error, key, `${option.name}${isEndWithConsonant(option.name) ? '은' : '는'} 필수입니다.`)
          return
        }
      }
      this.model.content = this.dataInHand.content
      EventBus.$emit('onLoading', true)
      const confirmed = confirm(`정말로 발송하시겠습니까?\n수신인: ${this.dataInHand.replyTo}` )
      
      const params = {
        ...this.model,
        messageId: this.model.messageId,
        managerId: this.userData.userId,
        comments: this.dataInHand.comments
      }
      
      if (confirmed) {
        sendInboxReply(params)
        .then(res => {
          setTimeout(() => {
            this.editMode = false
            this.loadData(alert('발송이 완료되었습니다.'))
          }, 1000)
        })
        .catch(e => {
          alert('발송 중 오류가 발생하였습니다.', e)
        })
        .finally(() => {
          this.$emit('reload')
          EventBus.$emit('onLoading', false)
        })
      } else {
        EventBus.$emit('onLoading', false)
      }
    },
    setModel () {
      this.model = {}
      for (const [field, option] of Object.entries(this.dataOption.field)) {
        if (option.key || option.editable) {
          this.model[option.field || field] = this.dataInHand[option.field || field]
        }
      }
      this.model.messageId = this.dataInHand.messageId
      this.model.references = this.dataInHand.references
    },
    setError (key, message) {
      this.$set(this.error, key, message)
    },
    closeModal () {
      this.show = false
      this.$emit('close')
    } 
  },
  data () {
    return {
      dataInHand: null,
      dataOption: null,
      editMode: false,
      show: false,
      model: {
        serviceType: this.$route.meta.ba ? 'ba' : 'beusable'
      },
      error: {}
    }
  }
}
</script>

<style lang="scss" scoped>
.detail {
  .remove-button {
    opacity: 0.5;
  }
}
</style>
